module.exports = __webpack_public_path__ + "img/rollback.e46d94a5.svg";